import CustomNumberInput from './CustomNumberInput';

export default CustomNumberInput;
